import { render, staticRenderFns } from "./list_table.vue?vue&type=template&id=496a2296&scoped=true"
import script from "./list_table.vue?vue&type=script&lang=ts"
export * from "./list_table.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "496a2296",
  null
  
)

export default component.exports